import { useUnit } from 'effector-react';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { $readOnly } from '../../entities/project';
import { $inspector, inspectorClosed } from '../../entities/selection';
import { AssumptionsInspector } from '../../features/edit-assumptions';
import { ItemInspector } from '../../features/edit-item';
import { ScenarioInspector } from '../../features/manage-variants';
import { IconButton, ReadOnlyProvider, Tooltip } from '../../shared/ui';
import { SharedItemsPanel } from './shared-items';

/** Right-hand detail panel: shows the selected item, variant or the global assumptions. */
export function Inspector() {
  const { t } = useTranslation();
  const [target, close, readOnly] = useUnit([$inspector, inspectorClosed, $readOnly]);
  if (!target) return null;

  return (
    <ReadOnlyProvider value={readOnly}>
      <aside aria-label={t('inspector.label')} className="relative flex h-full flex-col bg-bg-1">
        <div className="absolute top-2 right-2 z-10">
          <Tooltip content={t('inspector.close')} shortcut={['Esc']}>
            <IconButton label={t('inspector.close')} size="sm" onClick={close}>
              <X />
            </IconButton>
          </Tooltip>
        </div>
        {target.kind === 'item' && (
          <ItemInspector
            key={`${target.scenarioId}:${target.itemId}`}
            itemId={target.itemId}
            scenarioId={target.scenarioId}
          />
        )}
        {target.kind === 'scenario' && (
          <ScenarioInspector key={target.scenarioId} scenarioId={target.scenarioId} />
        )}
        {target.kind === 'assumptions' && <AssumptionsInspector />}
        {target.kind === 'shared' && <SharedItemsPanel />}
      </aside>
    </ReadOnlyProvider>
  );
}
